import { I18N } from "./I18N.js"
import { Toast } from "./Toast.js"

export class CookieConsent {

	constructor() {
		const cookiesAccepted = localStorage.getItem('cookiesAccepted')
		if (cookiesAccepted !== 'true') {
			const cookieToast = new Toast('toaster', I18N.translate('This website uses cookies. If you continue to use the website, we will assume your consent.'), Toast.INFO)
			cookieToast.okClickedPromise
				.then(() => localStorage.setItem('cookiesAccepted', true))
		}
	}

}